import React, { HTMLAttributes, HTMLProps } from 'react';

import { ImmutableGenericNodeEntity } from '..';
import NodeTipFull from './Full';
import NodeTipHighlighted from './Highlighted';
import NodeTipTeaser from './Teaser';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  viewMode: string;
  entity: ImmutableGenericNodeEntity;
}

const NodeTip: React.FC<Props> = ({ viewMode, entity, className }) => {
  switch (viewMode) {
    case 'teaser':
      return <NodeTipTeaser entity={entity} className={className} />;
    case 'highlighted':
      return <NodeTipHighlighted entity={entity} className={className} />;
    default:
      return <NodeTipFull entity={entity} className={className} />;
  }
};

export default NodeTip;
